import React, { Component } from 'react'
import { canShipmentBeMarkedVoid } from '@fielded/fs-api/lib/shipment/utils/utils'
import {withUser} from '../../../common/AuthenticationProvider'
import withConfig from '../../../van-shared/hoc/withConfig'
import { updateShipment } from '../../../root/reducers/shipments'
import flowRight from 'lodash/flowRight'
import { connect } from 'react-redux'
import withShipment from './../common/WithShipmentWrapper'
import {
  headerLocationFor,
  isShelflifeBasedApp,
  isAdminUser,
  isFpUser,
  isPsmResellerWarehouseUser
} from '../common/utils'
import shipmentsBreadcrumb from '../common/shipmentsBreadcrumb'
import { hasFeature } from '../../../van-shared/utils/features'

import ShipmentOptions from './ShipmentOptions'

class ShipmentOptionsContainer extends Component {
  componentDidMount () {
    const {
      shipment,
      updateShipment
    } = this.props

    updateShipment(shipment)
  }

  canDeleteShipment = () => {
    const { shipment, config, user } = this.props
    if (hasFeature(config.features, 'shipments:removeShipment') && canShipmentBeMarkedVoid(shipment)) {
      // for SL, only admin users can see delete shipment link
      if (isShelflifeBasedApp(config) && !isAdminUser(user)) {
        return false
      }

      return true
    }

    return false
  }

  render () {
    const { shipment, user, config } = this.props

    if (!shipment) return 'Something went wrong loading the options, please try again'
    const isPsmResellerWarehouse = isPsmResellerWarehouseUser(config, user)

    const addProductsLink = !isPsmResellerWarehouse && `/shipments/pick-list/${shipment.snapshotId}/shipment-options/add-product`

    const deleteProducts = (shipment.status !== 'received' && !isFpUser(user)) || isPsmResellerWarehouse
    const deleteShipmentLink = (this.canDeleteShipment() || isPsmResellerWarehouse) && `/shipments/pick-list/${shipment.snapshotId}/shipment-options/delete-shipment`

    return (
      <ShipmentOptions
        onRemoveShipment={this.handleRemoveShipment}
        breadcrumbItems={[shipmentsBreadcrumb]}
        closeUrl={`/shipments/pick-list/${shipment.snapshotId}`}
        headerLocation={headerLocationFor(shipment)}
        addProductsLink={addProductsLink}
        deleteProducts={deleteProducts}
        deleteShipmentLink={deleteShipmentLink}
        {...this.props}
      />
    )
  }
}

const mapDispatchToProps = {
  updateShipment
}

const withHOCs = flowRight(
  withConfig,
  withShipment,
  withUser,
  connect(null, mapDispatchToProps)
)

export default withHOCs(ShipmentOptionsContainer)
